import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { useCurrentWorkspace } from '@gripp/shared-logic';
import { Colors } from '@gripp/shared-ui';
import { StyleSheet, Text, View } from 'react-native';
import { ModalButton } from '../../shared/components/modalButton';
import { EditAddonForm } from './editAddonForm';

type EditAddonButtonProps = {
  label: any;
  addonId: string;
  onClose: () => void;
};

export const EditAddonButton = (props: EditAddonButtonProps) => {
  const currentWorkspace = useCurrentWorkspace();

  return (
    currentWorkspace && (
      <View style={styles.addonEditContainer}>
        <ModalButton
          label=""
          customButton={
            <View style={{ flexDirection: 'row' }}>
              <MaterialCommunityIcons
                name="pencil-outline"
                color={Colors.role.textPrimary}
                size={16}
                style={styles.icon}
              />
              <Text style={styles.label}>{props.label}</Text>
            </View>
          }
          buttonStyle={styles.editAddonButton}
          modalComponent={({ onComplete }) => {
            return (
              <EditAddonForm
                onComplete={() => {
                  onComplete();
                  props.onClose();
                }}
                workspaceId={currentWorkspace.id}
                addonId={props.addonId}
              />
            );
          }}
          containerStyle={styles.modalContainer}
        />
      </View>
    )
  );
};

const styles = StyleSheet.create({
  addonEditContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 20,
  },
  editAddonButton: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: 117,
    height: 32,
    backgroundColor: Colors.role.surface,
    borderRadius: 16,
  },
  icon: {
    marginRight: 4,
  },
  label: {
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: -0.25,
    color: Colors.role.textStrong,
  },
  modalContainer: {
    alignSelf: 'center',
    backgroundColor: Colors.role.surfaceHover,
    borderRadius: 10,
    width: 560,
    height: 240,
    justifyContent: 'flex-start',
  },
});
